import React from 'react'
import { Button } from '@/components/ui/button'
import { X, ChevronUp, ChevronDown, MoreVertical } from 'lucide-react'
import { useRouter } from '@tanstack/react-router'
import {Route as poRoute} from "@/routes/(inventory)/branch/_layout/purchase-orders/$id/index"

const Header = () => {
  const router = useRouter();
  const params = poRoute.useParams()
  const search = poRoute.useSearch()
  const data = poRoute.useLoaderData()
  return (
    <div className="flex items-center justify-between pt-2 px-2">
      <div className="flex items-center gap-1">
        <Button variant="ghost" size="icon" onClick={() => {
          router.navigate({
            to: "/branch/purchase-orders",
          })
        }}>
          <X className="h-4 w-4" />
        </Button>
        <Button variant="outline" size="sm" className='px-2' disabled={
          data.purchaseOrder.previousPurchaseOrderId === "00000000-0000-0000-0000-000000000000"
        } onClick={() => {
          router.navigate({
            to: "/branch/purchase-orders/$id",
            params: {
              id: data.purchaseOrder.previousPurchaseOrderId
            },
            search: {
              ...search,
            }
          })
        }}>
          <ChevronUp className="h-4 w-4" />
        </Button>
        <Button variant="outline" size="sm" className='px-2' disabled={
          data.purchaseOrder.nextPurchaseOrderId === "00000000-0000-0000-0000-000000000000"
        } onClick={() => {
          router.navigate({
            to: "/branch/purchase-orders/$id",
            params: {
              id: data.purchaseOrder.nextPurchaseOrderId
            },
            search: {
              ...search,
            }
          })
        }}>
          <ChevronDown className="h-4 w-4" />
        </Button>
        <p className='text-sm text-gray-600 ml-2'>{
              data.purchaseOrder.currentIndex + 1
            } {" "} of {data.purchaseOrder.totalCount} Purchase Orders</p>
      </div>
      <Button variant="ghost" size="icon">
        <MoreVertical className="h-4 w-4" />
      </Button>
    </div>
  )
}

export default Header 